import React, { useState, useContext } from 'react';
import { Check, History, User } from 'lucide-react';
import { WindowSizeContext } from '/src/App';

import './style.css';

const ThumbtackListing = ({ listing, handleIFrameClick }) => {
    const { deviceType } = useContext(WindowSizeContext);
    const {
        service_id,
        business_name,
        rating,
        num_reviews,
        years_in_business,
        num_hires,
        thumbtack_url,
        image_url,
        background_image_url,
        featured_review,
        quote,
        introduction,
        pills,
        location,
        is_top_pro,
        similar_jobs_done,
        license_verified,
        num_of_employees,
        has_background_check,
        business_location,
        request_flow_iframe_url,
        response_time_hours,
        service_category_name,
        service_page_iframe_url
    } = listing;

    // Create the state for whether to show the service / request flow iframe
    const [showIFrame, setShowIFrame] = useState(false);
    const [iframeUrl, setIframeUrl] = useState('');

    // Create a service page iframe id
    const service_page_iframe_id = `quoll-thumbtack-service-page-${service_id}`;


    // Take the service_page_iframe_url and replace the REPLACE_THIS_ID_WITH_YOUR_IFRAME_ELEMENT_ID with the service_page_iframe_id
    const service_page_iframe_url_with_id = service_page_iframe_url.replace('REPLACE_THIS_ID_WITH_YOUR_IFRAME_ELEMENT_ID', service_page_iframe_id);


    // Handle the button click to show the service / request flow iframe
    const handleIFrameClickWithinListing = (type) => {
        if (type === 'service_page') {
            handleIFrameClick(service_page_iframe_url_with_id, service_page_iframe_id);
        } else if (type === 'request_flow') {
            handleIFrameClick(request_flow_iframe_url, service_page_iframe_id);
        }
        // setShowIFrame(true);
    }



    // console.log('is_top_pro', is_top_pro);
    // console.log('pills', pills);
    // console.log('service_page_iframe_url', service_page_iframe_url);
    // console.log('service_page_iframe_url_with_id', service_page_iframe_url_with_id);
    // console.log('request_flow_iframe_url', request_flow_iframe_url);

    const pills_lookup = [
        { id: 'popular', name: 'Popular', color: 'good' },
        { id: 'licensed', name: 'Licensed', color: 'good' },
        { id: 'low_price', name: 'Great Value', color: 'good' },
        { id: 'overserved', name: 'Limited Availability', color: 'bad' },
    ]

    const enhanced_pills = pills.map(pill => {
        const lookup = pills_lookup.find(p => p.id === pill);
        return lookup ? { ...lookup, id: pill } : null;
    }).filter(Boolean);

    // If has_background_check is true, add the background_check pill to the enhanced_pills array at the start
    if (has_background_check) {
        enhanced_pills.unshift({ id: 'background_check', name: 'Background Checked', color: 'good' });
    }

    // If is_top_pro is true, add the top_pro pill to the enhanced_pills array at the start
    if (is_top_pro) {
        enhanced_pills.unshift({ id: 'top_pro', name: 'Top Pro', color: 'good' });
    }

    // console.log('enhanced_pills', enhanced_pills);

    let featured_review_truncated;
    if (featured_review) {
        featured_review_truncated = featured_review.substring(0, 200) + '...';
    }

    const companyInfoContainerList = []

    if (num_of_employees) {
        companyInfoContainerList.push({
            id: 'num_of_employees',
            value: num_of_employees,
            helper_text: 'Number of Employees'
        })
    }

    if (years_in_business) {
        companyInfoContainerList.push({
            id: 'years_in_business',
            value: `${years_in_business} years`,
            helper_text: 'Years in Business'
        })
    }

    const selectionButtons = [
        {
            id: 'service_page',
            name: 'View Profile',
        },
        {
            id: 'request_flow',
            name: 'Book Consult',
        },
    ]


    return (
        <div className={`thumbtack-listing ${showIFrame ? 'thumbtack-listing-iframe-open' : ''} ${deviceType}`}>
            <div className={`thumbtack-listing-pills ${deviceType}`}>
                {(enhanced_pills.length > 0 || is_top_pro) && (
                    <>

                        {enhanced_pills.length > 0 && (
                            enhanced_pills.map(pill => (
                                <div key={pill.id} className={`thumbtack-listing-pill ${pill.color}`}>
                                    <span className="thumbtack-listing-pill-text">{pill.name}</span>
                                </div>
                            ))
                        )}
                    </>
                )}
            </div>
            {!showIFrame && (
                <>
                    <div className={`thumbtack-listing-header ${deviceType}`}>
                        <div className="thumbtack-listing-image">
                            <img src={image_url} alt={business_name} />
                        </div>
                        <div className="thumbtack-listing-info">
                            <h3 className="thumbtack-listing-name text-align-center">{business_name}</h3>
                            <span className='thumbtack-listing-service-category'>{service_category_name}</span>
                        </div>
                    </div>
                    <div className={`thumbtack-listing-company-info-container ${deviceType}`}>

                        <div className="thumbtack-listing-rating">
                            <span className="rating-number">{rating.toFixed(1)}</span>
                            <div className="rating-stars">
                                {[...Array(5)].map((_, index) => (
                                    <span
                                        key={index}
                                        className={`star ${index < Math.floor(rating) ? 'filled' : ''}`}
                                    >★</span>
                                ))}
                            </div>
                            <span className="review-count">({num_reviews})</span>
                        </div>
                        {companyInfoContainerList.length > 0 && (
                            <>
                                {deviceType === 'desktop' && (
                                    <div className="thumbtack-listing-company-info-container-vertical-divider" />
                                )}
                                <div className={`thumbtack-listing-company-info-container-list ${deviceType}`}>
                                    {companyInfoContainerList.map(item => (
                                        <div className='thumbtack-listing-company-info-container-list-item' key={item.id}>
                                            <div className="thumbtack-listing-company-info-container-list-item-icon-container">
                                                {item.id === 'num_of_employees' && <User className="thumbtack-listing-company-info-container-list-item-icon" />}
                                                {item.id === 'years_in_business' && <History className="thumbtack-listing-company-info-container-list-item-icon" />}
                                            </div>
                                            <span className='thumbtack-listing-company-info-container-list-item-value'>{item.value}</span>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>

                    <div className={`thumbtack-listing-selection-buttons ${deviceType}`}>
                        {selectionButtons.map(button => (
                            <button key={button.id} onClick={() => handleIFrameClickWithinListing(button.id)} className="thumbtack-view-profile-btn">
                                {button.name}
                            </button>
                        ))}
                    </div>
                </>
            )}
            {showIFrame && (
                <div className="thumbtack-listing-iframe-container">
                    <iframe
                        src={iframeUrl}
                        id={service_page_iframe_id}
                        sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                    />
                </div>
            )}
        </div>
    );
};

export default ThumbtackListing;